import { gsap, Power3 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//Body Cursor Animation
export const WindowHover = (ele, ele2) => {
  document.body.addEventListener("mousemove", (event) => {
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    gsap.to([ele, ele2], {
      opacity: 1,
    });
    gsap.to(ele, {
      x: mouseX,
      y: mouseY,
      duration: 0,
    });
    gsap.to(ele2, {
      x: mouseX,
      y: mouseY,
      duration: 0.6,
    });
  });
  document.body.addEventListener("mouseleave", (event) => {
    gsap.to([ele, ele2], {
      opacity: 0,
    });
  });
};

//Loading Effect Animation
export let value = false;
export const loading = (
  node1,
  node2,
  node3,
  node4,
  node5,
  node6
) => {
  value = true;
  let tl = gsap.timeline({
    yoyo: true,
    repeatDelay: 2,
    autoAlpha: 1,
    repeat: 1,
  });
  tl.fromTo(
    [node2, node3],
    {
      delay: 0.5,
      opacity: 0.5,
      height: 0,
    },
    {
      opacity: 1,
      height: "100%",
      duration: 0.5,
      ease: "power4.easeinOut",
    }
  )
    .fromTo(
      node4,
      {
        opacity: 0.5,
        y: "100vh",
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power4.easeinOut",
      },
      "0.6"
    )
    .to(node5, {
      y: "0%",
      duration: 0.6,
      ease: "back.out",
    })
    .to(node6, {
      y: "0%",
      duration: 0.6,
      ease: "back.out",
    }, "<");
  gsap.to(node1, {
    height: 0,
    duration: 0.5,
    delay: 4.9,
    ease: "power3.easeinOut",
  });
};

// Hamburber Animations
export let tl = gsap.timeline({ duration: 0.5, reversed: true, delay: -0.7 });
export const hamburgerAnim = (node1, node2, node3) => {
  tl.to(
    node1,
    {
      attr: { d: "M8,2 L2,8" },
      x: 1,
      ease: Power3.easeInOut,
    },
    "start"
  );
  tl.to(
    node2,
    {
      autoAlpha: 0,
    },
    "start"
  );
  tl.to(
    node3,
    {
      attr: { d: "M8,8 L2,2" },
      x: 1,
      ease: Power3.easeInOut,
    },
    "start"
  );
};
export const closeMenu = (node1, node2, node3) => {
  gsap.to([node1, node2], {
    duration: 0.8,
    height: 0,
    ease: Power3.easeInOut,
    stagger: 0.1,
  });
  gsap.to(node3, {
    duration: 0.7,
    css: { display: "none" },
  });
};
export const revealMenus = (
  node1,
  node2,
  node3,
  node4,
  node5,
  node6,
  node7,
  node8
) => {
  gsap.to(node3, {
    duration: 0,
    css: { display: "block" },
  });
  gsap.to([node2, node1], {
    duration: 0,
    height: "100%",
    opacity: 1,
  });
  gsap.from([node2, node1], {
    duration: 0.8,
    height: 0,
    transformOrigin: "right top",
    skewY: 2,
    ease: Power3.easeInOut,
    stagger: 0.1,
  });
  gsap.from(node4, {
    duration: 1,
    y: 60,
    delay: 1,
    opacity: 0,
    ease: Power3.easeInOut,
  });
  gsap.from([node5, node6, node7, node8], {
    duration: 1,
    y: 100,
    delay: 0.1,
    opacity: 0,
    ease: Power3.easeInOut,
    stagger: 0.2,
  });
};
export const onEnter = (node) => {
  gsap.to(node, {
    y: 3,
    skewX: 4,
    duration: 0.3,
    ease: Power3.easeInOut,
  });
};
export const onLeave = (node) => {
  gsap.to(node, {
    y: -3,
    skewX: 0,
    duration: 0.3,
    ease: Power3.easeInOut,
  });
};

//Home Page Animations
export const homeanim = (
  node1,
  node2,
  node3,
  node4,
  node5,
  node6,
  node7,
  node8
) => {
  value = true;
  return gsap
    .timeline({ autoAlpha: 1 })
    .to(node1, {
      opacity: 1,
      duration: 0.2,
    })
    .fromTo(
      [node2, node3, node4, node5],
      {
        y: "80vh",
        opacity: 0,
      },
      {
        y: "0",
        opacity: 1,
        duration: 0.8,
        stagger: 0.2,
        ease: "power3.easeinOut",
      }
    )
    .set(node6, { autoAlpha: 1 })
    .fromTo(
      node6,
      {
        xPercent: "150",
      },
      {
        xPercent: "0",
        duration: 1.5,
        ease: "power2.out",
      }
    )
    .fromTo(
      node7,
      {
        xPercent: "-150",
        scale: 1.3,
      },
      {
        xPercent: "0",
        scale: 1,
        duration: 1.5,
        delay: -1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: node7,
          toggleActions: "restart none reverse restart",
        },
      }
    )
    .fromTo(
      node8,
      {
        y: "50px",
        opacity: 0,
      },
      {
        y: "0",
        opacity: 1,
        duration: 0.8,
        ease: "power3.easeinOut",
      },
      "<"
    );
};

//About Animations
export const about = (ele1, ele2, ele3, ele4, ele5) => {
  let tl1 = gsap.timeline();
  tl1
    .to(ele1, {
      opacity: 1,
      duration: 0.5,
      ease: "power4.in",
    })
    .set(ele2, { autoAlpha: 1 })
    .fromTo(
      ele2,
      {
        xPercent: "-150",
      },
      {
        xPercent: "0",
        duration: 1.5,
        ease: "power2.out",
      }
    )
    .fromTo(
      ele3,
      {
        xPercent: "150",
        scale: 1.3,
      },
      {
        xPercent: "0",
        scale: 1,
        duration: 1.5,
        delay: -1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ele2,
          toggleActions: "restart none restart restart",
        },
      }
    )
    .fromTo(
      [ele4, ele5],
      {
        y: "200px",
        opacity: 0,
      },
      {
        y: "0",
        opacity: 1,
        duration: 0.8,
        stagger: 0.4,
        ease: "power3.inOut",
      },
      "<"
    )
    // .set(summ, { autoAlpha: 1 })
    // .fromTo(
    //   summ,
    //   {
    //     xPercent: "-150",
    //   },
    //   {
    //     xPercent: "0",
    //     duration: 1.5,
    //     ease: "power2.out",
    //   }
    // )
    // .fromTo(
    //   summ1,
    //   {
    //     xPercent: "150",
    //     scale: 1.3,
    //   },
    //   {
    //     xPercent: "0",
    //     scale: 1,
    //     duration: 1.5,
    //     delay: -1.5,
    //     ease: "power2.out",
    //   }
    // )
};

//Project Animations
export const project = (nodd, nodd1) => {
  let tl = gsap.timeline({ delay: 0.5 });
  tl.fromTo(
    nodd,
    {
      y: "30vh",
      opacity: 0,
      skewY: 5,
      skewX: 20,
    },
    {
      y: 0,
      skewY: 0,
      skewX: 0,
      opacity: 1,
      duration: 1,
      ease: "power4.out(1)",
    }
  ).fromTo(
    nodd1,
    { clipPath: "circle(5% at 77%40%)", scale: 0.01, opacity: 0 },
    {
      clipPath: "circle(75% at 50%50%)",
      ease: "SlowMo.easeOut",
      scale: 1,
      opacity: 1,
      stagger: 0.2,
      rotation: 2 * 360,
      scrollTrigger: {
        trigger: nodd1,
        toggleActions: "restart none reverse restart",
      },
    },
    "<"
  );
};

//Project Details Slide-in Animations
export const initial = (element) => {
  gsap.fromTo(
    element,
    {
      x: "100vw",
    },
    {
      duration: 1.2,
      visibility: "visible",
      x: 0,
      opacity: 1,
      ease: Power3.easeInOut,
    }
  );
};
let see = gsap.timeline({ autoAlpha: 1 });
export const rightClick = (element1, element2) => {
  see.to(element1, {
    x: "-100vw",
    scale: 0.5,
    duration: 1,
    ease: Power3.easeInOut,
  });
  see.fromTo(
    element2,
    {
      x: "100vw",
      scale: 0.5,
    },
    {
      visibility: "visible",
      x: 0,
      scale: 1,
      opacity: 1,
      duration: 1.5,
      ease: Power3.easeInOut,
    },
    "<"
  );
};
let see2 = gsap.timeline({ autoAlpha: 1 });
export const leftClick = (element1, element2) => {
  see2.to(element1, {
    x: "100vw",
    scale: 0.5,
    duration: 1,
    ease: Power3.easeInOut,
  });
  see2.fromTo(
    element2,
    {
      x: "-100vw",
      scale: 0.5,
    },
    {
      visibility: "visible",
      scale: 1,
      x: 0,
      opacity: 1,
      duration: 1.5,
      ease: Power3.easeInOut,
    },
    "<"
  );
};

//Picture On nd Off
export const display = (elements) => {
  let tl = gsap.timeline({
    defaults: { duration: 1 },
    repeat: -1,
    autoAlpha: 1,
    ease: Power3.easeInOut,
  });
  const animateArray = Array.from(elements);
  animateArray.forEach(element => {
    tl.fromTo(
      element,
      { scale: 0.5, visibility: "hidden", opacity: 0 },
      {
        scale: 1,
        visibility: "visible",
        opacity: 1,
        yoyo: true,
        repeat: 1,
        repeatDelay: 1.5,
      }
    )
  });
  // tl.fromTo(
  //   ele,
  //   { scale: 0.5, visibility: "hidden", opacity: 0 },
  //   {
  //     scale: 1,
  //     visibility: "visible",
  //     opacity: 1,
  //     yoyo: true,
  //     repeat: 1,
  //     repeatDelay: 1.5,
  //   }
  // )
  //   .fromTo(
  //     ele2,
  //     { scale: 0.5, visibility: "hidden", opacity: 0 },
  //     {
  //       scale: 1,
  //       visibility: "visible",
  //       opacity: 1,
  //       yoyo: true,
  //       repeat: 1,
  //       repeatDelay: 1.5,
  //     }
  //   )
  //   .fromTo(
  //     ele3,
  //     { scale: 0.5, visibility: "hidden", opacity: 0 },
  //     {
  //       scale: 1,
  //       visibility: "visible",
  //       opacity: 1,
  //       yoyo: true,
  //       repeat: 1,
  //       repeatDelay: 1.5,
  //     }
  //   );
};

//Contact Animations
export const contact = (node1, node2, node3, node4, node5) => {
  let tl = gsap.timeline({ delay: 0.5 });
  tl.fromTo(
    [node1, node2, node3, node4, node5],
    {
      y: "60vh",
      opacity: 0,
      skewY: 5,
      skewX: 20,
    },
    {
      y: 0,
      skewY: 0,
      skewX: 0,
      opacity: 1,
      stagger: 0.2,
      duration: 1,
      ease: "back.out(1)",
    }
  );
};
